import createManagementPageLifecycle from "@shared/createManagementPageLifecycle.cjs";

export default createManagementPageLifecycle({
  navbar: "0",
  navbarHook: "mounted",
  loadMethods: ["loadDashboard"],
});
